export const GOOGLE_CLIENT_ID =
  "624277111507-tonhmmb6uesmngrrreb5jkglrl13lsq4.apps.googleusercontent.com";

export const GOOGLE_API_KEY = "AIzaSyBsuwsi6VPIGrSLoGqFLJMFtIECSIuESvw";
